const camelToWords = (value: string) => {
  if (value) {
    const decamelized = value
      .replace(/([A-Z]+)/g, " $1")
      .replace(/([A-Z][a-z])/g, " $1");
    return decamelized.charAt(0).toUpperCase() + decamelized.substring(1);
  }
  return null;
};

const undefinedToNull = (object: any): object => {
  const cloneObjUpdate = { ...object };
  Object.keys(object).forEach(key => {
    if (cloneObjUpdate[key] === undefined) {
      cloneObjUpdate[key] = null;
    }
  });
  return cloneObjUpdate;
};

export default { camelToWords, undefinedToNull };
